/**
 * Get the client's default time zone.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions}
 * @param {string} - Fallback to be used if timeZone could not be read
 * @returns {string} The current client's time zone (e.g. 'Europe/Berlin'), defaults to Greenwich Mean Time
 */
export function getIntlTimeZone(fallback = 'Europe/London') {
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        return timeZone || fallback
    } catch (ignore) {
        return fallback
    }
}
